'use client';

import { ProjectStoreProvider } from '@/providers/projectStoreProvider';
import { VodConnectionStoreProvider } from '@/providers/vodConnectionsStoreProvider';
import { FlattenProviders } from '@/providers/helper/FlattenProviders';
import { NotificationChannelProvider } from '@/components/NotificationChannelContext';
import { BillingProvider } from '@/features/billing/components/BillingContext';
import { InsufficientBalanceContextProvider } from '../billing/components/InsufficientBalanceContext';
import { UserStoreProvider } from '@/providers/userStoreProvider';

export const LayoutProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <FlattenProviders
      providers={[
        UserStoreProvider,
        NotificationChannelProvider,
        BillingProvider,
        InsufficientBalanceContextProvider,
        // TODO: revisit `VodConnectionStoreProvider`, `ProjectStoreProvider`, `UserStoreProvider`
        VodConnectionStoreProvider,
        ProjectStoreProvider,
      ]}
    >
      {children}
    </FlattenProviders>
  );
};
